<template>
    <DataTable
        :header="$t('productsSoldBasketAnalysis')"
        :fields="fields"
        :items="items"
        :filter="filter"
        :loading="request.getLoading()"
        :error="request.getError()"
        class="mb-4"
    >
        <template #headerSide>
            <div class="d-flex gap-3">
                <Multiselect
                    v-model="brand"
                    :options="optionsBrand"
                    searchable
                    select-label=""
                    :disabled="request.getLoading()"
                    class="width-200"
                />
                <b-form-input v-model="filter" class="width-200" :placeholder="$t('search')" />
            </div>
        </template>
        <template #cell(quantity)="{item}">
            <div>{{ item.quantity }}</div>
            <div><Difference :difference="$format.percent(calcPercentDiff(item.quantity, item.compareQuantity))" /></div>
        </template>
        <template #cell(amount)="{item}">
            <div>{{ $format.currency(item.amount) }}</div>
            <div><Difference :difference="$format.percent(calcPercentDiff(item.amount, item.compareAmount))" /></div>
        </template>
    </DataTable>
</template>



<script>
    import uniqBy from 'lodash/uniqBy';
    import { calcPercentDiff } from '@/utils/number';
    import DataTable from '@/components/common/DataTable.vue';
    import Difference from '@/components/common/Difference.vue';
    import Multiselect from '@/components/common/Multiselect.vue';

    export default {
        name: 'SoldProducts',
        components: {
            DataTable,
            Difference,
            Multiselect,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                request: this.$req('space/OtherProductsSales'),
                brand: null,
                filter: null,
            };
        },
        computed: {
            optionsBrand() {
                return uniqBy(
                    (this.request.getData() || []).filter(item => item.brand).map(item => ({ value: item.brand, text: item.brand })),
                    'value'
                );
            },
            items() {
                const items = this.request.getData() || [];
                if (this.brand) return items.filter(item => item.brand === this.brand.value);
                return items;
            },
            fields() {
                return [
                    { key: 'name', label: this.$t('product'), sortable: true },
                    { key: 'sku', label: this.$t('model'), sortable: true },
                    { key: 'brand', label: this.$t('brand'), sortable: true },
                    { key: 'quantity', label: this.$t('quantity'), sortable: true },
                    { key: 'amount', label: this.$t('salesAmount'), sortable: true },
                ];
            },
            spaceId() {
                return this.$store.state.space.currentSpaceId;
            },
            timeRange() {
                return this.parentComponent.timeRange;
            },
            apiParams() {
                const urlParams = { spaceId: this.spaceId };
                const requestParams = { ...(this.timeRange || {}) };
                return { urlParams, requestParams };
            },
        },
        watch: {
            spaceId: {
                handler: 'loadData',
            },
            timeRange: {
                handler: 'loadData',
            },
        },
        methods: {
            calcPercentDiff,
            loadData() {
                this.fetchData();
            },
            fetchData() {
                this.request.get(this.apiParams);
            },
        },
        created() {
            this.loadData();
        },
    };
</script>



<style lang="scss" scoped></style>
